import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actionShared } from '../../containers/Widget/actions.js';

import ShareButton from './ShareButton';
import MailIcon from '../Svg/MailIconFooter';
import Link from './Link';

import { copyFor } from '../../copy/copy';

const getMailUrl = (publisherName, actionType, articleUrl) => {
    const subject = copyFor('sharing', 'mailSubject', actionType, undefined, {
        publisherName
    });
    const body = copyFor('sharing', 'mailBody', actionType, undefined, {
        publisherName,
        articleUrl
    });
    return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
        body
    )}`;
};

const MailShare = props => (
    <Link
        href={getMailUrl(props.publisherName, props.actionType, props.shareUrl)}
        onClick={() => props.actionShared('mail')}
        target="_blank"
        title={copyFor('sharing', 'mail')}
    >
        <ShareButton>
            <MailIcon />
        </ShareButton>
    </Link>
);

MailShare.propTypes = {
    publisherName: PropTypes.string.isRequired,
    actionType: PropTypes.string.isRequired,
    shareUrl: PropTypes.string.isRequired,
    actionShared: PropTypes.func.isRequired
};

export default connect(
    state => ({
        shareUrl: state.widget.articleUrl,
        actionType:
            state.router.location.pathname !== '/multiActionsCard' &&
            state.router.location.pathname !== '/targetedMultiAction' &&
            state.router.location.pathname !== '/singleAction'
                ? state.widget.activeAction.type
                : 'multipleActions',
        publisherName:
            state.widget.twitterMention !== undefined
                ? '@' + state.widget.twitterMention
                : state.widget.publisherName || 'Speakable'
    }),
    {
        actionShared
    }
)(MailShare);



// WEBPACK FOOTER //
// ./src/components/SocialShareFooter/MailShare.jsx